<template>
	<transition name="modal">
		<div class="modal-mask" v-show="show">
			<div class="modal-container">
				<div class="modal-header">
					<h3 v-show="$props.cancelar">Cancelar a solicitação?</h3>
					<h3 v-show="$props.confirmar">Confirmar a solicitação?</h3>
					<h3 v-show="$props.adicionarInformacao">Adicionar informações à solicitação?</h3>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<div class="form-group">
								<label v-show="$props.cancelar" for="">Motivo do cancelamento:</label>
								<label v-show="$props.confirmar" for="">Observação (opcional):</label>
								<label v-show="$props.adicionarInformacao" for="">Informações:</label>
								<textarea v-model="dados.observacao" class="form-control" rows="10"></textarea>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<div class="text-right" style="float:right">
						<button class="btn btn-default" @click="$emit('close')">
								<i class="fa fa-close"></i> Fechar
							</button>
						<button v-show="$props.cancelar" @click="cancelarSolicitacao()" type="button" class="btn btn-primary">
								<span class="fa fa-check"></span> Confirmar
							</button>
						<button v-show="$props.confirmar" @click="confirmarSolicitacao()" type="button" class="btn btn-primary">
								<span class="fa fa-check"></span> Confirmar
							</button>
						<button v-show="$props.adicionarInformacao" @click="addInformacao()" type="button" class="btn btn-primary">
								<span class="fa fa-paper-plane"></span> Enviar
							</button>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
	import axios from 'axios' // Cliente para requisição http
	export default {
		props: ['show', 'solicitacao', 'cancelar', 'confirmar', 'adicionarInformacao'],
		filters: {},
		data: () => ({
			dados: {
				observacao: ''
			}
		}),
		mounted() {},
		methods: {
			cancelarSolicitacao() {
				if (!this.dados.observacao) {
					this.$swal({
						type: "warning",
						title: "Atenção!",
						text: "Não é possível cancelar sem uma justificativa. Preencha o motivo do cancelamento.",
					});
				} else {
					let loader = this.$loading.show()
					this.$store.commit('TOGGLE_LOADING');
					this.dados.solicitacaoId = this.$props.solicitacao.id;

					axios.post(`${this.$store.state.serverURI}/api/atendimentos/cancelar`, this.dados, this.$store.getters.getHeaderAuth)
						.then(response => {
							loader.hide()
							this.$emit("solicitacaoCancelada", response.data);
							this.dados.observacao = "";
							this.$store.commit('TOGGLE_LOADING');
						}).catch((error) => {
							console.log(error)
						});
				}
			},
			confirmarSolicitacao() {
				let loader = this.$loading.show()
				this.$store.commit('TOGGLE_LOADING');
				this.dados.solicitacaoId = this.$props.solicitacao.id;

				axios.post(`${this.$store.state.serverURI}/api/atendimentos/confirmar`, this.dados, this.$store.getters.getHeaderAuth)
					.then(response => {
						loader.hide()
						this.$emit("solicitacaoConfirmada", response.data);
						this.dados.observacao = "";
						this.$store.commit('TOGGLE_LOADING');
					}).catch((error) => {
						console.log(error)
					});
			},
			addInformacao() {
				if (!this.dados.observacao) {
					this.$swal({
						type: "warning",
						title: "Atenção!",
						text: "Preencha o campo com as informações adicionais.",
					});
				} else {
					let loader = this.$loading.show()
					this.$store.commit('TOGGLE_LOADING');
					this.dados.solicitacaoId = this.$props.solicitacao.id;

					axios.post(`${this.$store.state.serverURI}/api/atendimentos/adicionarInformacao`, this.dados, this.$store.getters.getHeaderAuth)
						.then(response => {
							loader.hide()
							this.$emit("informacaoAdicionada", response.data);
							this.dados.observacao = "";
							this.$store.commit('TOGGLE_LOADING');
						}).catch((error) => {
							console.log(error)
						});
				}
			},
		},
		components: {}
	};
</script>

<style scoped>
	* {
		box-sizing: border-box;
	}

	.modal-mask {
		position: fixed;
		z-index: 1001;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, .5);
		transition: opacity .3s ease;
	}

	.modal-container {
		width: 30%;
		height: auto;
		margin: 60px auto 0;
		padding: 10px;
		background-color: #fff;
		border-radius: 2px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
		transition: all .3s ease;
		font-family: Helvetica, Arial, sans-serif;
	}

	.modal-header h3 {
		margin-top: 0;
		color: #333;
	}

	.modal-body {
		height: 250px;
		overflow-y: auto;
	}

	.text-right {
		text-align: right;
	}

	.form-label {
		display: block;
		margin-bottom: 1em;
	}

	.form-label>.form-control {
		margin-top: 0.5em;
	}

	.form-control {
		display: block;
		width: 100%;
		padding: 0.5em 1em;
		line-height: 1.5;
		border: 1px solid #ddd;
	}


	/*
																			 * The following styles are auto-applied to elements with
																			 * transition="modal" when their visibility is toggled
																			 * by Vue.js.
																			 *
																			 * You can easily play with the modal transition by editing
																			 * these styles.
																			 */

	.modal-enter {
		opacity: 0;
	}

	.modal-leave-active {
		opacity: 0;
	}

	.modal-enter .modal-container,
	.modal-leave-active .modal-container {
		-webkit-transform: scale(1.1);
		transform: scale(1.1);
	}

	.modal {
		display: block !important;
		/* I added this to see the modal, you don't need this */
	}


	/* Important part */

	.modal-dialog {
		overflow-y: initial !important;
	}

	.modal-body {
		height: 300px;
		overflow-y: auto;
	}
</style>



// WEBPACK FOOTER //
// modalConfirmarCancelar.vue?08a76af7